// 云展厅管理路由表
import carcloudRouter from "@/views/carcloudPages/router.js";

// 全民营销路由表
import marketingRouter from "@/views/marketing/router.js";

// 微信机器人路由表
import weChatRobotRouter from "@/views/weChatRobot/router.js";

import newRetailRouter from "@/views/newRetail/router.js";

// 欧拉新零售路由表
import oraNewRetailRouter from "@/views/oraNewRetail/router.js";

// 品牌资讯路由表
import realTimeInfoRouter from "@/views/realTimeInfo/router.js";

// 挪车码
import moveCar from "@/views/moveCar/router.js";

// 经销商相关路由
import distributor from "@/views/distributor/router.js";

const menu = [
  ...carcloudRouter,
  ...marketingRouter,
  ...weChatRobotRouter,
  ...newRetailRouter,
  ...oraNewRetailRouter,
  ...moveCar,
  ...realTimeInfoRouter,
  ...distributor,
];
// 统一权限菜单 一级菜单 为模块
export default menu;
